export const requestTypes = Object.freeze({
	GET: Symbol("GET"),
	POST: Symbol("POST"),
	PUT: Symbol("PUT"),
	DELETE: Symbol("DELETE"),
});
